export default __webpack_public_path__ + "static/media/xinyi.fe74cecf.png";